import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';
import { PersonGrid } from '@/common/styles/shared.styles';

export const HomePersonGridLayout = styled(PersonGrid)`
	min-width: 0;
	width: 100%;
	max-width: 100%;
`;

export const LoadMoreWrap = styled.div`
	margin-top: 24px;
	text-align: center;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		margin-top: 18px;
		padding-bottom: 4px;
	}
`;

export const PersonCardSkeleton = styled.article`
	position: relative;
	overflow: hidden;
	width: 100%;
	aspect-ratio: 0.72;
	border-radius: 24px;
	background: #070509;
	box-shadow: 0 18px 44px rgba(0, 0, 0, 0.42);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		border-radius: 16px;
		box-shadow: 0 10px 24px rgba(0, 0, 0, 0.36);
		aspect-ratio: 0.72;
	}
`;

export const PersonCardSkeletonInfo = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
	padding: 0 22px 22px;
	display: flex;
	flex-direction: column;
	gap: 10px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 0 10px 12px;
		gap: 8px;
	}
`;
